import React, { useState } from 'react';
import styled from 'styled-components';
import useGlobal from '../store';

const EmergencyContactStyled = styled.section`
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    border: 1px solid ${(props) => props.theme.colors.backgrounds.altoGrey};
    max-width: 523px;
    font-family: ${(props) => props.theme.fonts[0]};

    &.open {
        background-color: #fff;
        box-shadow: 0 0 1rem rgba(0, 0, 0, 0.1);
    }

    &.close {
        border: none;
    }

    & .contact--icon {
        align-self: center;
        padding: 1rem;
        flex-basis: 144px;
        cursor: pointer;
        &:hover > .circle {
            background-color: ${(props) =>
                props.theme.colors.buttons.primaryHover};
            border: 1px solid ${(props) => props.theme.colors.white};
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
        }
        & .circle {
            width: 62px;
            height: 62px;
            border: 5px solid ${(props) => props.theme.colors.white};
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
            background-color: ${(props) => props.theme.colors.secondary};
            border-radius: 50px;
            position: relative;
            left: 5px;
            transition: all 0.2s ease-in-out;
            &:before,
            &:after {
                content: '';
                position: absolute;
                width: 3px;
                background-color: ${(props) => props.theme.colors.white};
                left: 46%;
                border-radius: 5px;
            }
            &:before {
                height: 18px;
                top: 25%;
            }
            &:after {
                height: 3.5px;
                top: 67%;
            }

            & + figcaption {
                font-size: 0.68rem;
                width: 75px;
                word-break: break-word;
                display: block;
                line-height: 0.93rem;
                text-align: center;
                padding: 0.31rem;
                text-shadow: 1px 1px 1px ${(props) => props.theme.colors.white};
                color: ${(props) => props.theme.colors.texts.capeCod};
                font-family: ${(props) => props.theme.fonts[0]};
            }
        }
    }

    & .contact--details {
        line-height: 1.2rem;
        border-left: 1px solid
            ${(props) => props.theme.colors.backgrounds.altoGrey};
        padding: 1.9rem;
        .close& {
            display: none;
        }
        & > p {
            font-size: 0.875rem;
            font-family: ${(props) => props.theme.fonts[0]};
            color: ${(props) => props.theme.colors.texts.graphiteLight};
            &:not(:last-child) {
                font-size: 0.625rem;
                margin-bottom: 0.3rem;
                text-transform: uppercase;
                color: ${(props) => props.theme.colors.texts.graphite};
            }
            & > a {
                text-decoration: none;
                color: ${(props) => props.theme.colors.primary};
                font-weight: 600;
            }
        }

        & > .hideContact {
            position: absolute;
            right: 1rem;
            top: 1rem;
            transform: scale(1.5);
            cursor: pointer;
            font-weight: 400;
            color: ${(props) => props.theme.colors.texts.boulderGrey};
        }
    }
`;

export default function EmergencyContact() {
    const [isOpen, setIsOpen] = useState(false);
    const [globalState, globalActions] = useGlobal();
    const defaultSection = {emergency_contact:{}}
    const {
        footer: {
            emergency_contact: emergency_contact,            
        } = defaultSection,
    } = globalState;
    return (
        <EmergencyContactStyled className={isOpen ? 'open' : 'close'}>
            <article className="contact--icon" onClick={() => setIsOpen(true)}>
                <figure className="circle"></figure>
                <figcaption>Emergency Contact</figcaption>
            </article>
            <article className="contact--details">
                <figure
                    className="hideContact"
                    onClick={() => setIsOpen(false)}
                >
                    {' '}
                    &times;{' '}
                </figure>
                <p>Emergency</p>
                <p>
                    In case of emergency, please call us at{' '}                    
                    <a href={`tel:${emergency_contact?.href}`}>{emergency_contact?.title}</a>{' '}
                    {/* <a href="tel:(432) 699-9366">(432) 699-9366</a>{' '} */}
                </p>
            </article>
        </EmergencyContactStyled>
    );
}
